<template>
  <ol class="p-entry-step">
    <li :class="{ active: step.first }">
      <div class="p-entry-step-circle">
        <span class="step">STEP</span>
        <span class="num">1</span>  
      </div>
      <p v-if="isLogin" class="p-entry-step-text">ご連絡先電話番号を入力</p>
      <p v-else class="p-entry-step-text">学校・先生情報を入力</p>
    </li>
    <li :class="{ active: step.second }">
      <div class="p-entry-step-circle">
        <span class="step">STEP</span>
        <span class="num">2</span>  
      </div>
      <p class="p-entry-step-text">教材を選択</p>
    </li>
    <li :class="{ active: step.third }">
      <div class="p-entry-step-circle">
        <span class="step">STEP</span>
        <span class="num">3</span>  
      </div>
      <p v-if="isLogin" class="p-entry-step-text">利用登録完了</p>
      <p v-else class="p-entry-step-text">お申し込み完了</p>
    </li>
  </ol>
</template>
<script setup lang="ts">
import { reactive, watch } from 'vue';

const props = defineProps<{
  step: 1 | 2 | 3;
  isLogin: boolean;
}>();

const step = reactive({
  first: false,
  second: false,
  third: false,
});

watch(() => props.step, (newVal, _) => {
  switch (newVal) {
    case 1:
      step.first = true;
      step.second = false;
      step.third = false;
      break;
    case 2:
      step.first = true;
      step.second = true;
      step.third = false;
      break;
    case 3:
      step.first = true;
      step.second = true;
      step.third = true;
      break;
  }
}, { immediate: true });
</script>
